import { isTieredVariant } from '@lub0v/santa-utils';
import { AccountUpgradeView } from '@src/components/PremiumUpsell/AccountUpgradeView';
import { useStartPremiumPurchase } from '@src/components/PremiumUpsell/premiumInterest';
import { PremiumAccessSummary } from '@src/components/PremiumBadge/PremiumAccessSummary';
import { purchasedTier, premiumTierName, PREMIUM_TIERS, type PremiumTier } from '@src/components/PremiumBadge/tierIdentity';
import '@src/components/PremiumBadge/PremiumTierIdentity.css';
import { useTranslation } from 'react-i18next';
import { Button, SettingsSection, Stack, Typography } from '@src/components';
import { CrownIcon } from '@src/components/icons/CrownIcon';
import './AccountPlanSection.css';
import { PremiumUpsell } from '@src/components/PremiumUpsell/PremiumUpsell';
import { useAppSelector } from '@src/state/hooks';

export function AccountPlanSection() {
  const { t, i18n } = useTranslation();
  const user = useAppSelector((state) => state.session.user);
  const startPurchase = useStartPremiumPurchase();
  const ru = i18n.language.startsWith('ru');
  const tier = purchasedTier(user);
  const next = isTieredVariant(user?.premium?.variant) ? user?.premium?.offers.find(item => item.status === 'upgrade') : undefined;
  const nextPrice = next?.amountDueMinor == null ? '' : new Intl.NumberFormat(i18n.language, { style: 'currency', currency: user!.premium!.currency, minimumFractionDigits: next.amountDueMinor % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(next.amountDueMinor / 100);
  const premium = user?.isPremium === true;
  return (
    <SettingsSection
      title={t('account.plan.title')}
      hint={premium ? (ru ? 'Ваш тариф и доступные возможности.' : 'Your plan and available features.') : t(user?.isGuest ? 'account.plan.guestHint' : 'account.plan.hint')}
      icon={<CrownIcon />}
      testId="account-plan"
    >
      <Stack gap={4} wide>
        {premium ? (
          <div className="account-plan__premium" data-premium-tier={tier} data-testid="account-plan-premium">
            <span className="account-plan__crown" data-premium-tier={tier} aria-hidden="true"><CrownIcon /></span>
            <div>
              <Typography as="h3" role="title/sub" color="inherit">{tier ? `${ru ? 'Вы —' : 'You are a'} ${premiumTierName(tier, ru)}` : t('account.plan.activeTitle')}</Typography>
              {user && <PremiumAccessSummary user={user} />}
              {next && next.tier !== 'full' && <Button className="account-plan__upgrade" variant="premium-light" onClick={() => startPurchase('account-tier-upgrade', 'account', 'profile', next.tier)} testId="account-tier-upgrade">
                <AccountUpgradeView tier={next.tier}>{PREMIUM_TIERS[next.tier as PremiumTier][ru ? 'actionRu' : 'actionEn']} · {nextPrice}</AccountUpgradeView>
              </Button>}
            </div>
          </div>
        ) : (
          <>
            <Typography as="h3" role="title/sub">
              {t('account.plan.free')}
            </Typography>
            <PremiumUpsell feature="account" compact />
          </>
        )}
      </Stack>
    </SettingsSection>
  );
}
